<div id="menu-header">
  <ul>
    <ng-container *ngFor="let item of menuHeader;">
      <ng-container *ngIf="!item.hidden">

        <!-- With children -->
        <li *ngIf="item.children && item.children.length>0; else noChildren" [class]="item.classList ?? ''"
          [class.flyout-open]="flyoutOpenItem === item">
          <div class="first-level">
            <mat-icon *ngIf="item.icon" class="menu-icon">{{item.icon}}</mat-icon>
            <mat-icon *ngIf="!item.icon && item.svgIcon" svgIcon="{{item.svgIcon}}" class="menu-icon"></mat-icon>
            <span *ngIf="item.translate === undefined || item.translate">{{ translations['menu'][item.title]}}</span>
            <span *ngIf="item.translate === false">{{ item.title }}</span>
          </div>
          <div class="back-layer"></div>
          <menu-header-item [items]="item.children" (flyoutStateChange)="setFlyoutOpen(item, $event)">
          </menu-header-item>
        </li>
      </ng-container>

      <!-- No children -->
      <ng-template #noChildren>
        <li *ngIf="!item.external" [class]="item.classList ?? ''">
          <a [title]="item.translate === undefined || item.translate ? translations['menu'][item.title] : (item.translate === false ? item.title : '')"
            [routerLink]="item.url">
            <div class="first-level">
              <mat-icon *ngIf="item.icon" class="menu-icon">{{item.icon}}</mat-icon>
              <mat-icon *ngIf="!item.icon && item.svgIcon" svgIcon="{{item.svgIcon}}" class="menu-icon"></mat-icon>
              <span *ngIf="item.translate === undefined || item.translate">{{ translations['menu'][item.title]}}</span>
              <span *ngIf="item.translate === false">{{ item.title }}</span>
            </div>
            <div class="back-layer"></div>
          </a>
        </li>

        <!-- Link externo -->
        <li *ngIf="item.external" [class.external]="item.external">
          <a [href]="item.url" target="_blank" title="{{ translations['menu'][item.title] }}">
            <div class="first-level">
              <mat-icon *ngIf="item.icon" class="menu-icon">{{item.icon}}</mat-icon>
              <mat-icon *ngIf="!item.icon && item.svgIcon" svgIcon="{{item.svgIcon}}" class="menu-icon"></mat-icon>
              <span *ngIf="item.translate === undefined || item.translate">{{ translations['menu'][item.title]}}</span>
              <span *ngIf="item.translate === false">{{ item.title }}</span>
            </div>
            <div class="back-layer"></div>
          </a>
        </li>
      </ng-template>

    </ng-container>
  </ul>
</div>
